import tw from "twin.macro";
import styled from "styled-components";

/** Shared CTA sizing — fixed 48px height sitewide */
const ctaCore = tw`inline-flex items-center justify-center h-12 px-8 text-sm font-bold tracking-wide rounded-full transition duration-300 focus:outline-none focus:shadow-outline whitespace-nowrap`;

export const PrimaryButton = styled.button`
  ${ctaCore}
  ${tw`bg-primary-500 text-gray-100 hocus:bg-primary-700 hocus:text-gray-200`}
`;

export const SecondaryButton = styled.button`
  ${ctaCore}
  ${tw`border-2 border-primary-500 text-primary-500 bg-transparent hocus:bg-primary-500 hocus:text-gray-100`}
`;

export const PrimaryCtaLink = styled.a`
  ${ctaCore}
  ${tw`bg-primary-500 text-gray-100 hocus:bg-primary-700 hocus:text-gray-200`}
`;

export const SecondaryCtaLink = styled.a`
  ${ctaCore}
  ${tw`border-2 border-primary-500 text-primary-500 bg-transparent hocus:bg-primary-500 hocus:text-gray-100`}
`;

/** For use on primary/teal backgrounds (GetStarted banner) */
export const InvertedPrimaryCtaLink = styled.a`
  ${ctaCore}
  ${tw`bg-gray-100 text-primary-500 shadow-lg hocus:bg-primary-700 hocus:text-gray-200`}
`;

export const OutlinedOnPrimaryCtaLink = styled.a`
  ${ctaCore}
  ${tw`text-gray-100 border-2 border-gray-500 hocus:bg-gray-100 hocus:text-primary-500 hocus:border-primary-500`}
`;

/** Store / app download buttons with icon */
export const StoreCtaLink = styled.a`
  ${ctaCore}
  ${tw`w-auto min-w-[14rem] px-6 bg-gray-100 text-gray-900 hocus:bg-gray-300 hocus:text-gray-900 shadow uppercase`}
`;
